// extracted by mini-css-extract-plugin
export default {"main":"viewTenant_main__Fx8sG","heading":"viewTenant_heading__mvGJr","root":"viewTenant_root__-9gS0","backdrop":"viewTenant_backdrop__BBi64","cssRoot":"viewTenant_cssRoot__9PIQl"};